import { ref, watch, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useThreadStore } from '@/stores/thread'

export function useAutoScroll() {
	const threadStore = useThreadStore()
	const isScrollingUp = ref(false)
	const lastScrollPosition = ref(0)

	function scrollToBottom(smooth = true): void {
		window.scrollTo({ top: document.body.scrollHeight, behavior: smooth ? 'smooth' : 'auto' })
	}

	function handleUserInteraction(): void {
		if (threadStore.isStreaming) threadStore.setUserInteracted()
	}

	function handleScroll(): void {
		if (!threadStore.isStreaming) return
		const currentScroll = window.pageYOffset || document.documentElement.scrollTop
		isScrollingUp.value = currentScroll < lastScrollPosition.value
		lastScrollPosition.value = currentScroll <= 0 ? 0 : currentScroll
		if (isScrollingUp.value) handleUserInteraction()
	}

	watch(
		() => threadStore.thread?.messages?.length ?? 0,
		async () => {
			await nextTick()
			scrollToBottom()
		}
	)

	watch(
		() => [threadStore.messageStream, threadStore.reasoningMessageStream],
		async () => {
			if (!threadStore.userInteracted) {
				await nextTick()
				scrollToBottom()
			}
		}
	)

	watch(
		() => threadStore.requestScrollBottom,
		async () => {
			await nextTick()
			scrollToBottom()
		}
	)

	onMounted(() => {
		lastScrollPosition.value = window.pageYOffset
		window.addEventListener('scroll', handleScroll)
	})

	onBeforeUnmount(() => {
		window.removeEventListener('scroll', handleScroll)
	})

	return { handleUserInteraction, scrollToBottom }
}
